<script setup lang="ts">
import { inject } from 'vue'

import { AccordionContextSymbol } from '@/components/Accordion/context'
import type { ElementalTypeEnum } from '~~/src/types/elemental'

const { title } = defineProps<{
  title?: string
  isLoading?: boolean
  elementalsType: ElementalTypeEnum

}>()

const accordeonContext = inject(AccordionContextSymbol)

if (!accordeonContext)
  throw new Error('Accordeon context not found')

const handlerToggle = () => {
  accordeonContext.toggle()
}

const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1)

const { isOpen } = accordeonContext
</script>

<template>
  <button
    flex
    items-center
    w-full
    gap-2.5
    text-dark-gray
    p-2
    transition-colors
    type="button"
    @click="handlerToggle"
  >
    <span w-4 h-4 flex items-center>
      <slot name="icon" />
    </span>
    <p class="font-bold text-xs">
      {{ capitalize(title || '') }}
    </p>
    <div
      i-material-symbols:keyboard-arrow-down
      transition="transform 200ms ease-in-out"
      :class="{
        'rotate-180': isOpen,
      }"
    />
  </button>
</template>
